export default "__VITE_ASSET__kgmcYRivaHzNpECSxzT_pQ__"